module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "history"
  }, [_vm._v("\n    Historik\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7893a576"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/common/history.vue
// module id = 291
// module chunks = 1